<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Payment Modes</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card-text>
        <v-row class="subtitle-2 text--primary">
          <v-col cols="12">
            <v-btn color="primary" small to="/new-payment-mode">
              <v-icon left dark>mdi-plus</v-icon>New Payment Mode
            </v-btn>
          </v-col>
          <v-col cols="12">
            <v-data-table
              :loading="loading"
              loading-text="Loading... Please wait"
              :headers="headers"
              :items="recordsData"
              :search="search"
            >
              <template v-slot:item.action="{ item }">
                <v-btn
                  icon
                  :to="`/payment-modes/${item.id}`"
                  text
                  color="accent"
                >
                <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    loading: false,
    editItem: {},
    loader: false,
    editDialog: false,
    recordsData: [],
    headers: [
      { text: "Name", value: "Name" },
      { text: "Action", value: "action" }
    ]
  }),
  methods: {
    getRecords() {
      const self = this;
      this.loading = true;
      this.$store
        .dispatch("get", `/payment-modes`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.recordsData = res.ResponseData;
            self.loading = false;
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getRecords();
  }
};
</script>